import type { UIMatch } from 'react-router';

import type { CmsSplatLoaderData } from './CmsSplatLoaderData';

export function isSearchLandingSSRMatch(
  match: UIMatch,
): match is UIMatch<
  Extract<CmsSplatLoaderData, { type: 'SEARCH_LANDING_PAGE' }>
> {
  if (match.id !== 'cms-route') return false;

  const data = match.loaderData as CmsSplatLoaderData | undefined;
  if (!data) return false;

  return data.type === 'SEARCH_LANDING_PAGE';
}
